export default __webpack_public_path__ + "static/media/sekolahmu.240562bd.svg";